import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M13.061 1.136a1.35 1.35 0 0 0-2.122 0L9.192 3.358l-2.719-.77a1.35 1.35 0 0 0-1.717 1.247l-.107 2.824-2.653.974a1.35 1.35 0 0 0-.656 2.02L2.913 12 1.34 14.348a1.35 1.35 0 0 0 .656 2.018l2.653.975.107 2.824a1.35 1.35 0 0 0 1.717 1.248l2.72-.771 1.746 2.221a1.35 1.35 0 0 0 2.122 0l1.747-2.221 2.719.77a1.35 1.35 0 0 0 1.717-1.247l.107-2.824 2.653-.975a1.35 1.35 0 0 0 .656-2.018L21.087 12l1.573-2.348a1.35 1.35 0 0 0-.656-2.019l-2.653-.974-.107-2.824a1.35 1.35 0 0 0-1.717-1.248l-2.719.77zM10.31 4.364 12 2.214l1.691 2.15c.338.43.903.614 1.43.464l2.631-.746.104 2.734a1.35 1.35 0 0 0 .884 1.216l2.568.944-1.523 2.272a1.35 1.35 0 0 0 0 1.503l1.523 2.273-2.568.944a1.35 1.35 0 0 0-.884 1.216l-.104 2.733-2.632-.746a1.35 1.35 0 0 0-1.429.465L12 21.786l-1.69-2.15a1.35 1.35 0 0 0-1.43-.465l-2.632.746-.104-2.733a1.35 1.35 0 0 0-.884-1.216l-2.568-.944 1.523-2.273a1.35 1.35 0 0 0 0-1.503L2.692 8.976l2.568-.944a1.35 1.35 0 0 0 .884-1.216l.104-2.734 2.632.746a1.35 1.35 0 0 0 1.43-.464m-.78 7.106a.75.75 0 1 0-1.06 1.06l2 2a.75.75 0 0 0 1.06 0l4-4a.75.75 0 0 0-1.06-1.06L11 12.94z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }